module.exports = {
    test:{
        'test' : '测试',
    },
}


// WEBPACK FOOTER //
// ./src/Language/Language/zh_cn.js